/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AresResponseSchema } from '../models/AresResponseSchema';
import type { FindInfoResponseSchema } from '../models/FindInfoResponseSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CoreApi {
    /**
     * Get Data From Ares
     * @returns AresResponseSchema OK
     * @throws ApiError
     */
    public static coreGetDataFromAresGet({
        regNumber,
    }: {
        regNumber: string,
    }): CancelablePromise<AresResponseSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/core/ares/',
            query: {
                'reg_number': regNumber,
            },
        });
    }
    /**
     * Get Data From Reg
     * @returns FindInfoResponseSchema OK
     * @throws ApiError
     */
    public static coreGetDataFromRegGet({
        regNumber,
    }: {
        regNumber: string,
    }): CancelablePromise<FindInfoResponseSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/core/data_from_reg/',
            query: {
                'reg_number': regNumber,
            },
        });
    }
}
